export default "__VITE_ASSET__DuYAULlS__"